import selectors from '../../../rootSelectors';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { highlightPossibleResponse, resetSelectedIndex } from '../../../common/questions/questionsActions';
import NW_AUDIO_INSTRUCTIONS from '../../nwConstants';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';
import { PRACTICE } from '../../../constants/assessmentItemType';

export const playPracticeScript = (stimulusAudio) => async (dispatch, getStore) => {
    const state = getStore();
    const correctResponse = selectors.getNWPracticeCorrectResponseId(state, PRACTICE);
    dispatch(highlightPossibleResponse(correctResponse));
    dispatch(setAvatarInstructions([NW_AUDIO_INSTRUCTIONS.practiceClickInstruction]));
    await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    dispatch(resetSelectedIndex());
    await dispatch(playAvatarAudio(
        NW_AUDIO_INSTRUCTIONS.practiceClickInstruction,
        GENERAL_AUDIO_DELAY,
    ));
};

export const narratePracticeScreen = (stimulusAudio) => async (dispatch) => {
    await dispatch(playAvatarAudio(
        [NW_AUDIO_INSTRUCTIONS.generalInstruction],
        GENERAL_AUDIO_DELAY,
    ));
    return dispatch(playPracticeScript(stimulusAudio));
};

export const narratePracticeReadyScreen = () => (dispatch) => {
    dispatch(setAvatarInstructions([NW_AUDIO_INSTRUCTIONS.practiceAnswerInstruction]));
    return dispatch(playAvatarAudio([NW_AUDIO_INSTRUCTIONS.practiceAnswerInstruction]));
};
